module.exports = [{"type":"title","text":"2023-10-12"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續合約/現貨：相同訂單限制為1秒最多撤銷一次"},{"type":"html","text":"現貨新增訂單類型：TAKE_ STOP_ LIMIT:限價止盈止損單TAKE_ STOP_ MARKET:市價止盈止損單TRIGGER_ LIMIT：限價計畫委託TRIGGER_ MARKET：市價計畫委託"},{"type":"html","text":"現貨：歷史訂單返回新增fee手續費欄位"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-10-12.json
// module id = DJaF
// module chunks = 3